module.exports = __webpack_public_path__ + "static/media/how-lawyerup-works.3dfaba8b.mp4";